import { render } from "./FractionCalculate.vue?vue&type=template&id=4533daa2"
import script from "./FractionCalculate.vue?vue&type=script&lang=js"
export * from "./FractionCalculate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__